import Auth0Lock from 'auth0-lock'
import auth0 from 'auth0-js';

import { __ } from '~/i18n'

const removeSlash = (value) => {
  return value.replace(/\/$/, "");
};

const isAllowed = (list) => {
  const cleanedList = list.map(val => {
    return removeSlash(val);
  });

  return cleanedList.indexOf(removeSlash(window.location.href)) > -1;
};

export default class Auth {
  defaultAuthConfig = {
    params: {
      scope: 'openid name nickname picture profile email',
    },
    responseType: 'token id_token',
  };

  defaultWebAuthConfig = {
    responseType: 'token id_token',
    scope: 'openid name nickname picture profile email'
  };

  constructor(config, shopConfig) {

    let redirectUri;
    const { allowedUrls, ...restConfig } = config;

    if(allowedUrls && allowedUrls.length > 0 && isAllowed(allowedUrls)) {
      redirectUri = removeSlash(window.location.href);
    } else if (!window.location.origin) {
      redirectUri = window.location.protocol + "//"
        + window.location.hostname
        + (window.location.port ? ':' + window.location.port : '');
    } else {
      redirectUri = window.location.origin;
    }

    redirectUri = redirectUri + '/';

    this.redirectUri = redirectUri;

    const options = {
      language: (shopConfig.language || shopConfig.defaultLanguage || 'et').substring(0,2),
      autoclose: true,
      auth: {
        ...this.defaultAuthConfig,
        audience: config.audience,
        redirectUrl: redirectUri,
      },
      theme: {
        logo: "https://storage.googleapis.com/gratify-frontend/colored-cart-2.png",
        primaryColor: '#1DA57A'
      },
      languageDictionary: {
        title: __('Gratify Cart')
      },
    };

    this.auth0 = new auth0.WebAuth({
      ...this.defaultWebAuthConfig,
      redirectUri,
      ...restConfig,
    });

    this.lock = new Auth0Lock(config.clientID, config.domain, options);
  }

  getUserInfo = (accessToken) => {
    return new Promise((resolve, reject) => {
      this.lock.getUserInfo(accessToken, (error, profile) => {
        if(error) {
          reject(error);
        } else {
          resolve(profile);
        }
      });
    });
  };

  handleAuthenticated = () => {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          const session = this.setSession(authResult);
          this.auth0.client.userInfo(authResult.accessToken, function(err, user) {
            // Now you have the user's information
            resolve({...session, user});
          });

        } else if (err) {
          console.log(err);
          reject(err);
        }
      });
    });
  };

  renewAuth = () => {
    return new Promise((resolve, reject) => {
      this.auth0.renewAuth({
        redirectUri: this.redirectUri,
        usePostMessage: true
      }, function (error, renewAuthResult) {
        if(error) {
          reject(error);
        }else {
          resolve(renewAuthResult);
        }
      });
    });
  };

  setSession = (authResult) => {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());

    return {
      accessToken: authResult.accessToken,
      idToken: authResult.idToken,
      expiresAt
    }
  };
}
